import React from 'react';

interface PageHeaderProps {
  title?: string;
  subtitle?: string;
  variant?: 'centered' | 'left';
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  variant = 'centered',
}) => {
  if (variant === 'left') {
    return (
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-2">
          {title}
        </h1>
        {subtitle && (
          <p className="text-gray-600 dark:text-gray-400">
            {subtitle}
          </p>
        )}
      </div>
    );
  }

  return (
    <div className="text-center mb-8">
      <h1 className="text-4xl font-bold text-gray-900 dark:text-gray-100 mb-2">
        {title}
      </h1>
      {subtitle && (
        <p className="text-lg text-gray-600 dark:text-gray-400">
          {subtitle}
        </p>
      )}
    </div>
  );
};
